import itemQuickform from "./warehousesale-quickform.html";

const dialog = require("../../../../../production/components/dialog/dialog");
const quickformEntity = require("../../../../../production/components/quickform/quickform-entity");
const quickformHandler = require("../../../../../production/components/quickform/quickform-handler");
const { formCopy } = require("./warehousesale-quickform-form");
const { form } = require("./warehousesale-quickform-form");
const textfieldMultiselect = require("../../../../../production/components/textfield/textfield-multiselect");

/****************ELEMENTS*****************/
var htmlQf = {};
var HTMLwasSelected = false;
let dbId;

function HTMLselect(detail) {
  quickformHandler.HTMLselect(
    "sale", //database table name****
    "warehousesale-quickform",
    detail.ev.target, //source, for example AC
    itemQuickform,
    form,
    formCopy,
    htmlQf
  );

  HTMLwasSelected = true;
} /**/

export function start(detail) {
  if (!HTMLwasSelected) {
    HTMLselect(detail);
  }

  obj[detail.act].start(detail);
}

const obj = {
  addOne: {
    start: (detail) => {
      addOne(detail, htmlQf);
    },
  },
  hide: {
    start: (detail) => {
      quickformEntity.hide(detail, htmlQf);
    },
  },
  prepareAdd: {
    start: (detail) => {
      quickformEntity.prepareAdd(detail, htmlQf);
    },
  },
  confirm: {
    start: (detail) => {
      confirmItem(detail, htmlQf);
    },
  },
  itemConformation: {
    start: (detail) => {
      itemConformation(detail, htmlQf);
    },
  },
};

function addOne(detail, htmlQf) {
  quickformEntity.addOne(detail, htmlQf);
}

export function setupItemsContainer(detail, htmlFC) {
  dbId = htmlFC.fullcontHTML.getAttribute("data-dbid");

  const sourceLines = htmlFC.fullcontHTML.querySelectorAll(
    "#sale_form_sale_vs_item .line"
  );

  detail.act = "prepareAdd";
  start(detail);

  const targetContainer = htmlQf.quickformHTML.querySelector(
    "#sale_form_sale_vs_item_2"
  );
  targetContainer.innerHTML = "";

  sourceLines.forEach((line) => {
    const clonedLine = line.cloneNode(true);
    targetContainer.appendChild(clonedLine);
  });

  targetContainer.setAttribute("data-dbid", dbId);

  const poFields = targetContainer.querySelectorAll(".line .otherField");
  const purchaseOrders = [];
  poFields.forEach((field) => {
    const fieldData = field.getAttribute("otherfield");
    if (fieldData) {
      const { po } = JSON.parse(fieldData);
      purchaseOrders.push(po.toUpperCase());
    }
  });

  const currentTotal = purchaseOrders.length;
  const invoicesConfirm =
    JSON.parse(localStorage.getItem(`invoiceConfirm${dbId}`)) || [];
  const matchedCount = invoicesConfirm.filter((po) =>
    purchaseOrders.includes(po.toUpperCase())
  ).length;

  let confirmCounter = htmlQf.quickformHTML.querySelector(".confirm-counter");

  confirmCounter.innerHTML = `<p>${matchedCount}/${currentTotal}</p>`;

  const chipCont = targetContainer.querySelectorAll(".line .chip-cont");
  chipCont.forEach((chip) => {
    if (!chip.querySelector(".warning-container")) {
      const warningDiv = document.createElement("div");
      warningDiv.className = "warning-container";

      const warningText = document.createElement("p");
      warningText.textContent = "\u26A0";

      warningDiv.appendChild(warningText);
      chip.appendChild(warningDiv);
    }
  });

  verifyQtyItem();
}

function itemConformation(detail, htmlQf) {
  const input = htmlQf.quickformHTML.querySelector("#confirmInput");
  const inputValue = input?.value.trim().toUpperCase() || "";
  const targetContainer = htmlQf.quickformHTML.querySelector(
    "#sale_form_sale_vs_item_2"
  );

  const container = htmlQf.quickformHTML.querySelectorAll(
    "#sale_form_sale_vs_item_2 .line"
  );
  container.forEach((line) => {
    const otherField = line.querySelector(".otherField");
    if (otherField) {
      const fieldData = otherField.getAttribute("otherfield");
      if (fieldData) {
        const { po } = JSON.parse(fieldData);
        // Realizar la comparación aquí
        if (inputValue === po) {
          // Aquí puedes agregar la lógica que deseas ejecutar cuando hay coincidencia
          // Por ejemplo, cambiar el color del input, mostrar un mensaje, etc.
          setLocalStorage(dbId, po);
          input.value = ""; // Limpiar el input después de la coincidencia
          verifyQtyItem();
        }
      }
    }
  });
}

// Función auxiliar para actualizar la UI de un ítem confirmado
function updateUIForItem(itemCode, container, itemCodes) {
  const index = itemCodes.indexOf(itemCode);
  if (index === -1) return;

  const itemLines = container.querySelectorAll(
    "#sale_form_sale_vs_item_2 .line"
  );
  const confirmedLine = itemLines[index];
  const chipCont = confirmedLine.querySelector(".chip-cont");
  const chip = confirmedLine.querySelector(".chip");
  const warningContainer = confirmedLine.querySelector(".warning-container");

  // Animación y estilos para el ítem confirmado
  if (chipCont) {
    chipCont.classList.add("a-shake");
    setTimeout(() => chipCont.classList.remove("a-shake"), 100);
  }

  if (chip) chip.classList.add("chip-green");
  if (warningContainer) {
    chipCont.style.backgroundColor = "#77ffa03c";
    warningContainer.className = "check-container";
    warningContainer.textContent = "\u2713";
  }
}

function setLocalStorage(dbId, purchaseOrder) {
  const key = `invoices${dbId}`;
  let purchaseOrders = JSON.parse(localStorage.getItem(key)) || []; // Obtener el array existente o crear uno nuevo

  // Verificar si el valor ya existe en el array
  if (!purchaseOrders.includes(purchaseOrder)) {
    purchaseOrders.push(purchaseOrder); // Agregar el nuevo valor al array
    localStorage.setItem(key, JSON.stringify(purchaseOrders)); // Guardar el array actualizado en localStorage
  }
}

function verifyQtyItem() {
  const key = `invoices${dbId}`;
  const invoices = JSON.parse(localStorage.getItem(key)) || [];
  const imgCheck = htmlQf.quickformHTML.querySelector(
    ".icon-container .check-svg"
  );
  const imgScanner = htmlQf.quickformHTML.querySelector(
    ".icon-container .scanner-svg"
  );
  const targetContainer = htmlQf.quickformHTML.querySelector(
    "#sale_form_sale_vs_item_2"
  );
  const counter = htmlQf.quickformHTML.querySelector(".confirm-counter");
  let matchedCount = 0;
  let currentTotal = 0;

  if (invoices.length > 0 && targetContainer && counter) {
    // Verifica img también
    currentTotal = targetContainer.querySelectorAll(".line").length;
    const invoicesConfirm =
      JSON.parse(localStorage.getItem(`invoices${dbId}`)) || [];
    matchedCount = invoicesConfirm.filter((po) =>
      invoices.includes(po.toUpperCase())
    ).length;

    counter.innerHTML = `<p>${matchedCount}/${currentTotal}</p>`;

    invoices.forEach((invoice) => {
      const invoiceUpper = invoice.toUpperCase();
      if (invoicesConfirm.includes(invoiceUpper)) {
        updateUIForItem(invoiceUpper, targetContainer, invoicesConfirm);
      }
    });

    // Cambiar la imagen según el estado de coincidencia (usando rutas absolutas)
    if (matchedCount === currentTotal) {
      imgCheck.classList.remove("dn");
      imgScanner.classList.add("dn");
    }
  } else {
    imgScanner.classList.remove("dn");
    imgCheck.classList.add("dn");
    return [];
  }

  if (matchedCount < currentTotal) {
    imgScanner.classList.remove("dn");
    imgCheck.classList.add("dn");
  }
}
